import type { CivilGridFile } from '~/common/types';
import Icon from '~/components2/Icon';

interface Props {
  file: CivilGridFile;
  onDownload?: (file: CivilGridFile) => void;
  /** Shows the download as waiting on its signed URL. */
  pending?: boolean;
}

export default function ({ file, onDownload, pending = false }: Props) {
  return (
    <button
      type="button"
      onClick={() => {
        onDownload?.(file);
      }}
      disabled={pending}
      aria-busy={pending || undefined}
      aria-label={`Download ${file.name}`}
      data-testid={`message-file-download-${file.id}`}
      className="flex w-fit cursor-pointer items-center space-x-2 rounded bg-white p-1 text-left focus-ring disabled:cursor-wait disabled:opacity-60"
    >
      <Icon icon="file" className="text-brand" />
      <div className="overflow-hidden break-words">{file.name}</div>
    </button>
  );
}
